export default "https://cdn-static.gokick.com/assets/8bc125c24491fd75c87852671f08945500f37a20/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";